import React from "react";
import styled from "styled-components";
import { useTheme } from "../../../context/useThemeContext";

const HoverP = styled.p<{ $color: string; $hoverColor: string }>`
    transition: color 0.05s ease-in-out;
    color: ${(state) => state.$color};

    &:hover {
        color: ${(state) => state.$hoverColor};
    }
`;

export default function RedirectBTN(props: {
    name: string;
    onClick: () => void;
}) {
    const { theme } = useTheme();

    return (
        <HoverP
            $color={theme.fontColor[200]}
            $hoverColor={theme.fontColor[100]}
            className="cursor-pointer text-sm"
            onClick={(e:React.MouseEvent<HTMLParagraphElement>) => {
                e.preventDefault()
                e.stopPropagation()
                props.onClick();
            }}
        >
            {props.name}
        </HoverP>
    );
}
